<template>
  <!-- <div id="mySidenav" class="sidenav mt-5">
        <ul class="list-unstyled mt-md-3 mt-1 mb-3 mb-md-4 d-flex flex-column align-items-center">
            <li class="p-2" v-if="user.profile_image !==null">
                <img v-bind:src="user.profile_image"
                     style="height: 100px; width: 100px;border-radius: 50%" alt="">
            </li>
            <li class="p-2" v-else>
                <img src="./../../../../public/assets/icon.jpg"
                     style="height: 100px; width: 100px;border-radius: 50%" alt="">
            </li>
            <li class="p-2">
                <div class="dropdown">

                    <button class="btn dropdown-btn dropdown-toggle" type="button" id="dropdownMenuButton"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{user.display_name}}
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a @click="logout()" class="dropdown-item" href="#">Logout</a>
                    </div>
                </div>

            </li>
        </ul>
        <ul class="list-unstyled mt-5">
            <li class="p-2 ml-3 active-nav-item">
               <router-link to="/home" class="text-black"> <img src="./../../../assets/images/home_1.svg" class="pr-3 side-svg">Homepage</router-link>
            </li>
            <li class="p-2 ml-3 ">
                <router-link to="/community/members" class="text-black">  <img src="./../../../assets/images/community.svg" class="pr-3 side-svg">Vereniging</router-link>
            </li>
            <li class="p-2 ml-3">
                 <router-link to="/committees/all" class="text-black">  <img src="./../../assets/images/handshake.svg" class="pr-3 side-svg">Commissies</router-link>
            </li>
           <li class="p-2 ml-3">
                <router-link to="/itemgroups" class="text-black"> <img src="./../../assets/images/sitemap.svg" class="pr-3 side-svg">Itemgroups</router-link>
            </li>
            <li class="p-2 ml-3">
                <router-link to="/settings" class="text-black"><img src="./../../assets/images/Settings.svg" class="pr-3 side-svg">Instellingen</router-link>
            </li>
        </ul>
    </div> -->

  <nav class="navbar navbar-expand-lg navbar-light shadow-none">
    <div class="d-flex d-lg-none">
      <router-link to="/community/email">
        <img src="/assets/img/Email.svg" alt="" />
      </router-link>
      <div class="dropdown pb-0" v-if="user">
        <button
          class="btn dropdown-btn dropdown-toggle pt-0 pb-0"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          v-if="user.profile_image !== null"
        >
          <img
            v-bind:src="user.profile_image"
            style="height: 35px;width: 35px;border: 4px solid #4192D9;border-radius: 50%"
            alt=""
          />
        </button>
        <button
          class="btn dropdown-btn dropdown-toggle pt-0 pb-0 "
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          v-else
        >
          <img
            src="/assets/icon.jpg"
            style="height: 35px;width: 35px;border: 4px solid #4192D9;border-radius: 50%"
            alt=""
          />
        </button>

        <div
          style="left: unset;right: 0;"
          class="dropdown-menu"
          aria-labelledby="dropdownMenuButton"
        >
          <router-link
            v-if="user"
            v-bind:to="'/profile/' + user.id + '/view'"
            class="dropdown-item"
            href="#"
          >
            Profiel
          </router-link>
          <router-link
            v-if="user"
            v-bind:to="'/profile/' + user.id + '/password'"
            class="dropdown-item"
            href="#"
          >
            Wachtwoord
          </router-link>
          <a @click="logout()" class="dropdown-item" href="#">Uitloggen</a>
        </div>
      </div>
    </div>
    <button
      class="navbar-toggler navb-tog"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item navrightb mt-1 ml-2">
          <router-link class="nav-link text-dark hover" to="/home">
            Homepage
          </router-link>
        </li>
        <li class="nav-item navrightb mt-1 ml-2">
          <router-link class="nav-link text-dark" to="/community/members">
            Vereniging
          </router-link>
        </li>
        <li class="nav-item navrightb mt-1 ml-2">
          <router-link class="nav-link text-dark" to="/committees/3/all">
            Commissies
          </router-link>
        </li>
        <li class="nav-item navrightb mt-1 ml-2">
          <router-link class="nav-link text-dark" to="/groups/2/all">
            Groepen
          </router-link>
        </li>
        <li class="nav-item navrightb mt-1 ml-2">
          <router-link class="nav-link text-dark" to="/itemgroups">
            Informatie
          </router-link>
        </li>
        <li class="nav-item navrightb mt-1 ml-2">
          <router-link
            class="nav-link text-dark"
            to="/settings"
            v-if="showSettingMenuItem"
          >
            Instellingen
          </router-link>
        </li>
      </ul>
    </div>
  </nav>

  <!-- <div class="collapse navbar-collapse justify-content-start">
        <ul class="navbar-nav">

            <li class="nav-item navrightb mt-1 ml-2 ">
                <router-link class="nav-link text-dark hover" to="/home">
                    Homepage
                </router-link>
            </li>
            <li class="nav-item navrightb mt-1 ml-2 ">
                <router-link class="nav-link text-dark" to="/community/members">
                    Vereniging
                </router-link>
            </li>
            <li class="nav-item navrightb mt-1 ml-2 ">
                <router-link class="nav-link text-dark" to="/committees/3/all">
                    Commissies
                </router-link>
            </li>
            <li class="nav-item navrightb mt-1 ml-2 ">
                <router-link class="nav-link text-dark" to="/groups/2/all">
                    Groepen
                </router-link>
            </li>
            <li class="nav-item navrightb mt-1 ml-2 ">
                <router-link class="nav-link text-dark" to="/itemgroups">
                    Informatie
                </router-link>
            </li>
            <li class="nav-item navrightb mt-1 ml-2 " v-if="showSettingMenuItem">
                <router-link class="nav-link text-dark" to="/settings">
                    Instellingen
                </router-link>
            </li>


        </ul>
    </div> -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "sidebar",
  computed: {
    showSettingMenuItem() {
      return (
        this.userHasRoles(["Super-Admin"]) ||
        this.userHasPermissions([
          "Beheer Mailtemplates",
          "Beheer Emailadressen",
          "Financieel",
          "Beheer Activiteiten",
          "Beheer Groepen",
          "Beheer Commissies",
          "Beheer Informatie",
        ])
      );
    },
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
    }),
  },
  methods: {
    ...mapActions({
      logoutAction: "auth/signOut",
    }),

    async logout() {
      await this.logoutAction();

      this.$router.replace({ name: "login" });
    },
  },
  // methods:{
  //     ...mapActions({
  //         logoutAction : 'auth/signOut'
  //     }),
  //
  //     async logout () {
  //         await this.logoutAction()
  //
  //         this.$router.replace({ name: 'login' })
  //     }
  //
  // }
};
</script>

<style scoped>
.navbar-toggler {
  font-size: 1rem !important;
}
.sidenav {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 2px 0px 10px #4f546733;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
  z-index: 1029;
}
a:hover {
  color: #4192d9 !important;
}

@media screen and (max-height: 450px) {
  .sidenav {
    padding-top: 15px;
  }

  .sidenav a {
    font-size: 18px;
  }
}

.dropdown-btn.focus,
.dropdown-btn:focus {
  box-shadow: none;
}

.side-svg {
  height: 20px;
  width: 40px;
}
a:hover {
  text-decoration: unset;
}
.active-nav-item {
  filter: invert(0.5) sepia(1) saturate(5) hue-rotate(175deg);
}

.dropdown-toggle::after {
  content: unset !important;
}
</style>
